import { Buildings, Lightning, Notebook } from '@phosphor-icons/react';
import { useNavigate } from 'react-router';
import { Button, buttonStyles } from '@skupreme/shared/ui';
import { ShadowBox } from '@elements/Common';
import SecureLayout from '@layouts/SecureLayout';
import { BLURRED_PAGE, blurredBackground } from './UpgragePlan';

const POINTS = [
  'Quick Insights',
  'Real-Time Data to Stay Ahead',
  'Informed Decision-Making',
  'Replaces Multiple Tools',
];

function UpgradePlanBox() {
  const navigate = useNavigate();

  return (
    <ShadowBox className="sk:relative sk:z-[1000] sk:flex sk:flex-col sk:items-start sk:p-[50px]">
      <div>
        <Buildings size={40} weight="light" className="sk:text-brand" />
      </div>
      <div>
        <h1 className="sk:mx-auto sk:my-[0.3rem] sk:text-left sk:text-[2.25rem] sk:leading-[1.1] sk:font-bold sk:tracking-[-1.8px] sk:md:text-[2.75rem] sk:lg:text-[3.2rem]">
          Only available <br />
          in the Pro Plan
        </h1>
      </div>
      <ul className="sk:my-4 sk:flex sk:list-none sk:flex-col sk:items-start sk:p-0">
        {POINTS.map(point => (
          <li
            key={point}
            className="sk:my-2 sk:flex sk:items-center sk:gap-[5px] sk:text-xl"
          >
            <Lightning weight="light" />
            {point}
          </li>
        ))}
      </ul>
      <div className="sk:flex sk:gap-3">
        <Button
          variant="primary"
          size="lg"
          onPress={() => navigate('/app/settings/?tab=subscription')}
          className="sk:bg-brand sk:text-white sk:hover:bg-brand-hover"
        >
          <Buildings />
          Upgrade
        </Button>
        <a
          href="https://skupreme.com/knowledge-base"
          target="_blank"
          rel="noreferrer"
          className={buttonStyles({ variant: 'pill', size: 'lg' })}
        >
          <Notebook />
          Knowledge Base
        </a>
      </div>
    </ShadowBox>
  );
}

export function UpgradeProPlanTab() {
  return (
    <div className="sk:flex sk:w-full sk:items-center sk:justify-center sk:pt-[10%]">
      <UpgradePlanBox />
    </div>
  );
}

export function UpgradeProPlan({ menu }: { menu?: { key: string } }) {
  return (
    <SecureLayout customClass="sk:p-0!">
      <div className={BLURRED_PAGE} style={blurredBackground(menu?.key)}>
        <UpgradePlanBox />
      </div>
    </SecureLayout>
  );
}
